import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./TabBar.module.css";

export default function TabBar({ tabs }) {
  const [activeTab, setActiveTab] = useState(tabs[0].label);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const match = tabs.find((tab) => tab.label === activeTab);

  return (
    <div className={styles.container}>
      <div className={styles.buttonRow}>
        {tabs.map((tab) => (
          <button
            key={tab.label}
            className={activeTab === tab.label ? styles.activeTab : styles.tab}
            onClick={() => handleTabClick(tab.label)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className={styles.row}>{match && match.child}</div>
    </div>
  );
}

TabBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      child: PropTypes.node,
    })
  ),
};
